// NOTE: to avoid accidental ID collisions
var count = 0;
var nextId = function () {
    count += 1;
    return count;
};
export default (function (str) { return "profile-mfe-".concat(str !== null && str !== void 0 ? str : nextId()); });
